import React from "react";
import "./Home4.css";

const Home4 = () => {
  return (
    <div className="home4">
      <h1>Trip Advisor</h1>
      {/* <iframe
      title="Trip Advisor Reviews"
        src="https://widgets.sociablekit.com/tripadvisor-profile-reviews/iframe/25580526"
        frameborder="0"
        width="100%"
        height="1000"
      ></iframe> */}
<script src="https://static.elfsight.com/platform/platform.js" async></script>
<div className="elfsight-app-29fe7abf-c9f1-4c0a-9b44-d43edc84ac61" data-elfsight-app-lazy style={{ zIndex: 0 }}></div>
    </div>
  );
};

export default Home4;
